import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'HeroCarouselProgressBox',
})(({ breakpoints, typography: { pxToRem }, zIndex, brandColors, type }) => ({
  progressBox: {
    cursor: 'pointer',
    zIndex: zIndex.snackbar,
    display: 'flex',
    flexDirection: 'column',
    gap: pxToRem(24),

    [breakpoints.up('xs')]: { maxWidth: pxToRem(100) },
    [breakpoints.up('md')]: { maxWidth: pxToRem(283) },
  },
  progressBarTrack: {
    height: pxToRem(7),
    maxWidth: '100%',
    backgroundColor: '#FFFFFF80',

    [breakpoints.up('xs')]: { width: pxToRem(100) },
    [breakpoints.up('md')]: { width: pxToRem(283) },
  },
  progressBar: {
    width: '0%',
    height: '100%',
    backgroundColor: 'white',
  },
  progressDescription: {
    gap: pxToRem(8),
    flexDirection: 'column',

    '&:not(hover)': { color: '#FFFFFF80' },
    '&:hover': { color: brandColors.white },

    [breakpoints.up('xs')]: { display: 'none' },
    [breakpoints.up('md')]: { display: 'flex' },
  },
  progressDescriptionActive: {
    color: brandColors.white,
  },
  heading: {
    ...type['16_medium'],
  },
  subheading: {
    ...type['14_regular'],
  },
}));

export default useStyles;
